import React from 'react';
import { Star } from 'lucide-react';

export function ProviderReviewsList({ reviews, rating, brandName }) {
  if (!reviews || reviews.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
        <Star className="h-5 w-5 text-[#D4AF37]" />
        Reviews ({reviews.length})
        {rating && (
          <span className="text-sm font-normal text-stone-500 ml-1">
           , {rating} average
          </span>
        )}
      </h2>
      <div className="space-y-3" data-testid="provider-reviews">
        {reviews.map((review) => (
          <div key={review.review_id} className="card-surface p-5">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-full bg-[#F9F6F0] flex items-center justify-center text-[#D4AF37] font-medium">
                {review.client_name?.charAt(0) || '?'}
              </div>
              <div>
                <p className="font-medium text-[#1A1A1A] text-sm">{review.client_name || 'Client'}</p>
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, starIdx) => (
                    <Star
                      key={`profile-star-${starIdx}`}
                      className={`h-3.5 w-3.5 ${starIdx < review.rating ? 'text-[#D4AF37] fill-current' : 'text-stone-300'}`}
                    />
                  ))}
                </div>
              </div>
              {review.created_at && (
                <span className="text-xs text-stone-400 ml-auto">{new Date(review.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
              )}
            </div>
            {review.text && <p className="text-stone-600 text-sm">{review.text}</p>}
            {review.provider_response && (
              <div className="mt-3 ml-6 pl-4 border-l-2 border-[#D4AF37]" data-testid={`review-response-${review.review_id}`}>
                <p className="text-xs font-medium text-[#D4AF37] mb-1">Response from {brandName}</p>
                <p className="text-sm text-stone-600">{review.provider_response.text}</p>
                {review.provider_response.responded_at && (
                  <p className="text-xs text-stone-400 mt-1">{new Date(review.provider_response.responded_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
